// Third party
import React, { Component } from 'react';
import { Navbar, NavItem, Nav, Grid, Image } from 'react-bootstrap';

// Others
import googleAnalyticsKeys from '../../../utils/googleAnalyticsKeys';
import * as googleAnalyticsUtil from '../../../utils/googleAnalyticsUtil';

import './styles.css'

export class Header extends Component {
    componentDidMount() {
        window.onload = this.initPage();
    }

    //prevent from right click and opennig in a new tab for all images and hidden a link tags
    initPage = () => {
        var aCtrl = document.getElementsByTagName('a');
        for (var ind = 0; ind < aCtrl.length; ind++) {
            aCtrl[ind].oncontextmenu = function () {
                return false;
            }
        }
        var imgCtrl = document.getElementsByTagName('img');
        for (var i = 0; i < imgCtrl.length; i++) {
            imgCtrl[i].oncontextmenu = function () {
                return false;
            }
        }
    }

    handleSoleraRewardsLogoClick = () => {
        googleAnalyticsUtil.raiseEvent({
            category: googleAnalyticsKeys.categories.INTERNAL_LINK_NAVIGATION,
            action: googleAnalyticsKeys.actions.CLICK_SOLERA_LOGO
        });

        // Redirect to Solera Rewards site when clicking on Solera Rewards logo.
        const callbackUrl = this.props.callbackUrl;
        if (callbackUrl) {
            window.location.assign(callbackUrl);
        }
    }

    handleWhyJoinClick = () => googleAnalyticsUtil.raiseEvent({
        category: googleAnalyticsKeys.categories.INTERNAL_LINK_NAVIGATION,
        action: googleAnalyticsKeys.actions.CLICK_WHY_JOIN_LINK
    })

    handleFaqClick = () => googleAnalyticsUtil.raiseEvent({
        category: googleAnalyticsKeys.categories.INTERNAL_LINK_NAVIGATION,
        action: googleAnalyticsKeys.actions.CLICK_FAQ_LINK
    })

    handleRewardsClick = () => googleAnalyticsUtil.raiseEvent({
        category: googleAnalyticsKeys.categories.INTERNAL_LINK_NAVIGATION,
        action: googleAnalyticsKeys.actions.CLICK_REWARDS_LINK
    })

    handleSecurityAndPrivacyClick = () => googleAnalyticsUtil.raiseEvent({
        category: googleAnalyticsKeys.categories.INTERNAL_LINK_NAVIGATION,
        action: googleAnalyticsKeys.actions.CLICK_SECURITY_AND_PRIVACY_LINK
    })

    handleTermsAndConditionsClick = () => googleAnalyticsUtil.raiseEvent({
        category: googleAnalyticsKeys.categories.INTERNAL_LINK_NAVIGATION,
        action: googleAnalyticsKeys.actions.CLICK_TERMS_AND_CONDITIONS_LINK
    })

    handleContactUsClick = () => googleAnalyticsUtil.raiseEvent({
        category: googleAnalyticsKeys.categories.INTERNAL_LINK_NAVIGATION,
        action: googleAnalyticsKeys.actions.CLICK_CONTACT_US_LINK
    })

    render() {
        return (
            <Grid bsClass="header">
                <Grid bsClass="header-content">
                    <Navbar>
                        <Navbar.Header>
                            <Navbar.Brand>
                                <Image id="solera-logo" className="image-cusor" alt="Solera-Logo" src="/logo/logo-solera-rewards.svg" width="148" height="56" onClick={this.handleSoleraRewardsLogoClick} />
                            </Navbar.Brand>
                            <Navbar.Toggle id="header-links-expander" />
                        </Navbar.Header>
                        <Navbar.Collapse className="navbar-position">
                            <Nav id="header-links" pullRight>
                                <NavItem id="enrollment-link" className="header-title header-title-active" onClick={this.handleRewardsClick.bind(this)}>
                                    Rewards
                                </NavItem>
                                <NavItem id="why-join-link" className="header-title" href={`${this.props.callbackUrl}why-join`} onClick={this.handleWhyJoinClick.bind(this)}>
                                    Why Join
                                </NavItem>
                                <NavItem id="faq-link" className="header-title" href={`${this.props.callbackUrl}faq`} onClick={this.handleFaqClick.bind(this)}>
                                    Faq
                                </NavItem>
                                <NavItem id="security-and-privacy-link" className="header-title header-hidden-content" href={`${this.props.callbackUrl}security-and-privacy`} onClick={this.handleSecurityAndPrivacyClick.bind(this)}>
                                    Security &amp; Privacy
                                </NavItem>
                                <NavItem id="terms-and-conditions-link" className="header-title header-hidden-content" href={`${this.props.callbackUrl}terms-and-conditions`} onClick={this.handleTermsAndConditionsClick.bind(this)}>
                                    Rewards Terms &amp; Conditions
                                </NavItem>
                                <NavItem id="contact-us-link" className="header-title header-hidden-content" href={`${this.props.callbackUrl}contact-us`} onClick={this.handleContactUsClick.bind(this)}>
                                    Contact Us
                                </NavItem>
                            </Nav>
                        </Navbar.Collapse>
                    </Navbar>
                </Grid>
            </Grid>
        )
    }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/common/header/index.js